/**
 * @Time    : 2024/1/12 15:42
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { delCookie, getCookie, setCookie } from '@/utils/cookie';

// 从cookie中获取登陆的AccessToken
export const getAccessToken = () => getCookie(LOGIN_COOKIE_KEY) || undefined;

// 把AccessToken写入cookie
export const setAccessToken = (accessToken: string, expires = 2592000) => {
  const expiresTime = new Date(new Date().getTime() + expires * 1000);
  setCookie(LOGIN_COOKIE_KEY, accessToken, expiresTime);
};

// 跳转到登陆界面
export const redirectLogin = () => {
  // 清除cookie
  delCookie(LOGIN_COOKIE_KEY);

  const { pathname, origin, search } = window.location;
  // 路由白名单不走登陆校验，直接跳过
  if (LOGIN_WHITE_LIST_PATH.includes(pathname)) {
    return;
  }
  let redirect = pathname;
  if (pathname === LOGIN_CALLBACK_PATH) {
    redirect = '/';
  }
  // 跳转到登陆界面
  window.location.href = `${origin}${LOGIN_CALLBACK_PATH}?redirect=${redirect}${search}`;
};
